import './styles.scss';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Link, useParams} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {TranslationKeys} from '../../utils/constants/routeConstants';
import {
  articleAsyncActions, getTeiArticle, getTeiArticleTables
} from '../../redux/pageAsyncActions';
import Loader from '../../components/loader';
import ArticleTable from './ArticleTable';

import './styles.scss';

export const ArticleTables: React.FunctionComponent = () => {
  const {
    article,
    tables
  } = useSelector((state: IStore) => state.article);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const dispatch = useDispatch();
  const {articleId} = useParams();

  useGetTranslations({
    translationKey: TranslationKeys.Article
  });

  useEffect(() => {
    if (articleId) {
      if (!article || article.id.toString() !== articleId) {
        dispatch(articleAsyncActions[getTeiArticle](articleId));
      }
      dispatch(articleAsyncActions[getTeiArticleTables](articleId));
    }
  }, [articleId]);

  return <div className="tables-page">
    {article && <header className="tables-page__header">
      <h1><FormattedMessage
        id={'gritx.article.tables'}
        defaultMessage={'Tables'}
      /></h1>
      {article && <Link to={`/article/${article.id}`} className="tables-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to article'}
        /></Link>}
    </header>}
    {<main className="tables-page__container">
      {!tables.length && loading.includes(getTeiArticleTables) && <Loader className="tables-page__loader"/>}
      <div className="tables-page__body">
        {tables && tables.map((t, i) => {
          return <div key={i}>
            <ArticleTable table={t}/>
          </div>;
        })}
      </div>
    </main>}
  </div>;
};
